var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"tab-button yx-color-text-p-4 font-h4-regular",class:[_vm.curTab === item.name ? 'active' : ''],on:{"click":function($event){return _vm.click(item.name, item)}}},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }